import { electronicFormatIBAN, validateIBAN } from "ibantools";
import { iban } from "../../sql/classy/types";
import { isNil } from "./istype";

export function zipIsValid(zip: string) {
  if (zip.trim() !== "" && zip.length < 4) {
    return false;
  } else {
    return true;
  }
}

export function zipValidation(
  zip: string,
): { tag: "parsed"; parsed: string } | { tag: "err"; label: string } {
  return zipIsValid(zip)
    ? { tag: "parsed", parsed: zip }
    : { tag: "err", label: "Niet correct" };
}

export function nameIsValid(name: string) {
  if (name.trim() !== "" && name.match(/\d/)) {
    return false;
  } else {
    return true;
  }
}

export function nameValidation(
  name: string,
): { tag: "parsed"; parsed: string } | { tag: "err"; label: string } {
  return nameIsValid(name)
    ? { tag: "parsed", parsed: name }
    : {
        tag: "err",
        label: "Naam mag geen cijfers bevatten",
      };
}

export function urlValidation(
  str: string,
): { tag: "parsed"; parsed: string } | { tag: "err"; label: string } {
  try {
    new URL(str);
  } catch (err) {
    return {
      tag: "err",
      label: "Dit is geen geldige URL",
    };
  }
  return { tag: "parsed", parsed: str };
}

export function streetValidation(
  name: string,
): { tag: "parsed"; parsed: string } | { tag: "err"; label: string } {
  return nameIsValid(name)
    ? { tag: "parsed", parsed: name }
    : {
        tag: "err",
        label: "Straat mag geen cijfers bevatten",
      };
}

export function mandatoryValidation(
  s: string,
  opts?: { minNumberOfCharacters?: number },
): { tag: "parsed"; parsed: string } | { tag: "err"; label: string } {
  if (s.trim() === "") {
    return { tag: "err" as const, label: "Verplicht" };
  } else {
    if (
      !isNil(opts?.minNumberOfCharacters) &&
      s.trim().length < opts.minNumberOfCharacters
    ) {
      return {
        tag: "err" as const,
        label: "Moet minstens %n tekens bevatten".replace(
          "%n",
          opts.minNumberOfCharacters.toString(),
        ),
      };
    }
    return { tag: "parsed" as const, parsed: s };
  }
}

export function phoneIsValidSimple(ph: string) {
  if (ph.trim() !== "" && ph.length < 6) {
    return false;
  } else {
    return true;
  }
}

export function phoneValidationSimple(
  ph: string,
): { tag: "parsed"; parsed: string } | { tag: "err"; label: string } {
  return phoneIsValidSimple(ph)
    ? { tag: "parsed", parsed: ph }
    : {
        tag: "err",
        label: "Niet correct",
      };
}

export function ibanValidation(
  account: string,
): { tag: "parsed"; parsed: iban } | { tag: "err"; label: string } {
  const elec = electronicFormatIBAN(account.replace(/ /g, "")) as iban;
  const res = validateIBAN(elec);
  if (res.valid === false) {
    return { tag: "err", label: "De IBAN rekening is niet correct" };
  } else {
    return { tag: "parsed", parsed: elec };
  }
}
